import api from './api'

export const pedidosService = {
  /**
   * Lista pedidos con filtros opcionales.
   * @param {Object} filtros - { estado, origen, fecha_desde, fecha_hasta, cliente_id }
   */
  listar(filtros = {}) {
    return api.get('/pedidos', { params: filtros })
  },

  /**
   * Obtiene un pedido con sus detalles.
   * @param {number} id
   */
  obtener(id) {
    return api.get(`/pedidos/${id}`)
  },

  /**
   * Crea un nuevo pedido.
   * @param {Object} datos - { cliente_id, origen, notas, detalles[], subtotal, iva, total, ... }
   */
  crear(datos) {
    return api.post('/pedidos', datos)
  },

  /**
   * Actualiza un pedido existente.
   * @param {number} id
   * @param {Object} datos
   */
  actualizar(id, datos) {
    return api.put(`/pedidos/${id}`, datos)
  },

  /**
   * Cambia el estado de un pedido.
   * @param {number} id
   * @param {string} estado
   * @param {string|null} motivoCancelacion
   */
  cambiarEstado(id, estado, motivoCancelacion = null) {
    return api.patch(`/pedidos/${id}/estado`, {
      estado,
      motivo_cancelacion: motivoCancelacion
    })
  },

  /**
   * Obtiene los datos del pedido para pre-cargar el formulario de facturación.
   * NO emite la factura.
   * @param {number} id
   */
  convertir(id) {
    return api.post(`/pedidos/${id}/convertir`)
  },

  /**
   * Confirma la conversión: marca el pedido como 'facturado' y vincula la factura.
   * @param {number} id         - ID del pedido
   * @param {number} facturaId  - ID de la factura emitida
   */
  confirmarConversion(id, facturaId) {
    return api.post(`/pedidos/${id}/confirmar-conversion`, { factura_id: facturaId })
  }
}
